<label for="companyName" class="form-label" translate="field.advertiserName"></label>
<div [formGroup]="registerForm" class="input-group has-validation">
  <input type="text" class="form-control" id="companyName" formControlName="companyName"
         [ngClass]="{ 'is-invalid': isInvalid() }"
  />
  <div class="invalid-feedback" translate="field.required"></div>
</div>
